import { Component, OnInit, Input, ViewChild, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtmlPipe } from '../pipes/safe-html.pipe';


@Component({
    selector: 'app-content-viewer',
    templateUrl: './content-viewer.component.html',
    styleUrls: ['./content-viewer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SafeHtmlPipe]
})
export class ContentViewerComponent implements OnInit {

  @Input() content: string;
  @ViewChild('contentHtml', { static: true }) el: ElementRef;

  constructor() {
  }

  ngOnInit() {
    MathJax.Hub.Config({
      messageStyle: 'none',
      tex2jax: {inlineMath: [['$', '$'], ['\\(', '\\)']]}
    });
    MathJax.Hub.Queue(['Typeset', MathJax.Hub]);
  }
}
